/**
 * The constant NaN derived mathematically by 0 / 0.
 *
 * @type number
 */
const constantNAN = 0 / 0;

export default constantNAN;
